import { render, staticRenderFns } from "./CustomAutocompleteBase.vue?vue&type=template&id=96ff785c&"
import script from "./CustomAutocompleteBase.vue?vue&type=script&lang=js&"
export * from "./CustomAutocompleteBase.vue?vue&type=script&lang=js&"
import style0 from "./CustomAutocompleteBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
